import * as z from 'zod/mini';
export const CountryArray = ['US', 'PL'];
export const Country = z.enum(CountryArray);
export const CountryPhonePrefix = {
    US: '+1',
    PL: '+48',
};
//# sourceMappingURL=Country.js.map